import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-medal-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="medal-badge" [class]="'medal-' + medal" *ngIf="medal">
      <span class="medal-icon">{{ getMedalIcon() }}</span>
    </span>
  `,
  styles: [`
    .medal-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-left: 4px;
      font-size: 14px;
      vertical-align: middle;
    }

    .medal-icon {
      filter: drop-shadow(0 1px 1px rgba(0,0,0,0.3));
      display: inline-block;
    }

    /* Animation */
    @keyframes medalPulse {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.1);
      }
    }

    .medal-badge {
      animation: medalPulse 2s ease-in-out infinite;
    }

    /* Responsive sizes */
    :host-context(.small-text) .medal-badge {
      font-size: 12px;
      margin-left: 2px;
    }

    :host-context(.large-text) .medal-badge {
      font-size: 18px;
      margin-left: 6px;
    }
  `]
})
export class MedalBadgeComponent implements OnInit {
  @Input() medal: 'GOLD' | 'SILVER' | 'BRONZE' | null = null;

  ngOnInit(): void {}

  getMedalIcon(): string {
    switch (this.medal) {
      case 'GOLD':
        return '🥇';
      case 'SILVER':
        return '🥈';
      case 'BRONZE':
        return '🥉';
      default:
        return '';
    }
  }
}